import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const ThumbsUpActiveIcon: React.FC<Props> = props => {
  const size = props.size || 26;
  const color = props.color || '#f24006';
  return <Icon name={'project-thumbs-up-active'} size={size} color={color} />;
};

export default React.memo(ThumbsUpActiveIcon);
